module.exports = __webpack_public_path__ + "img/load.04950d95.gif";